
/**
 * beatles bridge部分方法对应bridge4中的方法
 * http://fe.in.didialift.com:8088/fe/hudamin/didibridge.md.html
 * http://fe.in.didialift.com:8088/fe/hudamin/jsbridge.md.html
 */
const aliasWithBridge4 = {
  openUrl: 'open_url',
  uploadImageBySelect: 'callbackImageLiteratureReview',
  uploadImageByCamera: 'callbackImageLiteratureReviewTakeCamera',
  uploadImageByPhotoLibrary: 'callbackImageLiteratureReviewPhotoLibrary'
};

/**
 * beatles bridge部分方法对应bridge5中的方法 使用回调
 * http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=94909837
 */
const aliasWithBridge5 = {
  shareWxAppmsg: 'shareWeixinAppmsg',
  shareWxTimeline: 'shareWeixinTimeline',
  shareQQAppmsg: 'shareQqAppmsg',
  shareQZone: 'shareQzone',
  shareSinaWeibo: 'shareSinaWeibo'
};

export {aliasWithBridge4, aliasWithBridge5};



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/beatles/alias.js